// Migration: v2 → v3
// Rename parameter codes: @relationship → @relationship1, @name → @name1,
// @contactMobilePhone → @contactMobilePhone1, @contactHomePhone → @contactHomePhone1

import type { MigratableTemplateContent } from './types';

const PARAMETER_RENAMES: Record<string, string> = {
  '@relationship': '@relationship1',
  '@name': '@name1',
  '@contactMobilePhone': '@contactMobilePhone1',
  '@contactHomePhone': '@contactHomePhone1',
};

export const migrateV2ToV3 = (data: MigratableTemplateContent): void => {
  const widgets = data.widgets;
  if (!widgets || typeof widgets !== 'object' || Array.isArray(widgets)) {
    data.version = '3';
    return;
  }
  for (const widget of Object.values(widgets)) {
    if (widget.parameter && widget.parameter in PARAMETER_RENAMES) {
      widget.parameter = PARAMETER_RENAMES[widget.parameter];
    }
  }
  data.version = '3';
};
